export default "__VITE_ASSET__BTh5m2fN__"